import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../lang/LangEnum';
import { getMediaCover } from '../../lib/MediasLib';
import MediaRenderer from './MediaRenderer';

type Props = {
  media: any;
  show: boolean;
  onClose: () => void;
  mediaContentContain?: boolean;
};

export const MediaPreview = ({ media, show, onClose, mediaContentContain }: Props) => {
  const mediaUrl = getMediaCover(media);

  return (
    <Modal
      isOpen={show}
      size="standard"
      header={{ title: LangEnum.GLOBAL_PREVIEW }}
      onClose={onClose}
    >
      <MediaRenderer
        type={media.type}
        src={mediaUrl}
        mediaContentContain={mediaContentContain}
        autoPlay
      />
    </Modal>
  );
};
